import type { LucideIcon } from "lucide-react";
import {
  Building2,
  Database,
  Info,
  Key,
  LayoutDashboard,
  RefreshCcw,
  Settings,
  Users,
} from "lucide-react";

export interface RouteConfig {
  id: string;
  name: string;
  path?: string; // 그룹은 path 없이 토글만
  icon?: LucideIcon;
  children?: RouteConfig[];
  /** 특정 환경에서만 노출. local은 항상 허용 */
  onlyEnv?: "develop" | "staging01" | "prod";
}

export const routes: RouteConfig[] = [
  {
    id: "dashboard",
    path: "/",
    name: "대시보드",
    icon: LayoutDashboard,
  },

  // 프리즘 수집 현황 및 오류 (/collections/*) 
  {
    id: "prism-collection",
    name: "프리즘 수집 현황 및 오류",
    icon: Database,
    children: [
      { id: "collection_status", name: "수집 현황", path: "/collections/status" },
      { id: "collection_error", name: "수집 오류", path: "/collections/errors" },
      { id: "collection_data_size", name: "수집 데이터 크기", path: "/collections/size" },
      { id: "e2e_test_dashboard", name: "E2E 테스트 대시보드", path: "/collections/e2e-dashboard", onlyEnv: "develop" },
    ],
  },

  // 프리즘 설정 (/preferences/*)
  {
    id: "preferences",
    name: "프리즘 설정",
    icon: Settings,
    children: [
      { id: "prism_config", name: "프리즘 수집 설정", path: "/preferences/collection" },
      {
        id: "universal_throttling",
        name: "유니버셜 스로틀링 정책 설정",
        path: "/preferences/universal-throttling",
      },
      {
        id: "anomaly_detection",
        name: "이상 탐지 규칙 설정",
        path: "/preferences/anomaly-detection-rules",
      },
      {
        id: "data_forwarder",
        name: "데이터 포워더 정책 설정",
        path: "/preferences/data-forwarder-policy",
      },
      {
        id: "facebook_resource_target_date",
        name: "페이스북 리소스 조회일 지정",
        path: "/preferences/facebook-resource-date",
      },
      {
        id: "collection_delay_threshold",
        name: "채널별 수집 지연 시간 정의",
        path: "/preferences/channel-collection-delay",
      },
    ],
  },

  // 수집 오류 시 복구 기능 (/recover/*)
  {
    id: "recover",
    name: "수집 오류 시 복구 기능",
    icon: RefreshCcw,
    children: [
      {
        id: "data_forwarder_retry",
        name: "데이터 포워더 재처리",
        path: "/recover/data-forwarder-reprocess",
      },
      {
        id: "delete_apps_raw",
        name: "Appsflyer Raw 파일 삭제",
        path: "/recover/appsflyer-raw-file-delete",
      },
    ],
  },

  // 조직 관리 (/organization/*)
  {
    id: "organization",
    name: "조직 관리",
    icon: Building2,
    children: [
      { id: "onboarding", name: "Onboarding", path: "/organization/onboarding" },
      { id: "offboarding", name: "Offboarding", path: "/organization/offboarding" },
    ],
  },

  // 토큰 관리 (/tokens/*)
  {
    id: "tokens",
    name: "토큰 관리",
    icon: Key,
    children: [{ id: "tms_token_management", name: "TMS 토큰 관리", path: "/tokens/tms" }],
  },

  // 컨트롤 패널 유저 관리 (/users/*)
  {
    id: "users",
    name: "BackOffice 유저 관리",
    icon: Users,
    children: [
      { id: "prism_backoffice_user", name: "유저 관리", path: "/users" },
      { id: "prism_backoffice_user_grant_group", name: "유저 권한 그룹 관리", path: "/users/permission-groups" },
    ],
  },

  // 기타 기능 및 정보 (/info/*)
  {
    id: "info",
    name: "기타 기능 및 정보",
    icon: Info,
    children: [
      { id: "media_api_version", name: "매체 API 버전", path: "/info/media-api-version" },
      { id: "search_workspace", name: "워크스페이스 검색", path: "/info/workspace-search" },
      {
        id: "versioning_schedule_check",
        name: "매체 버전 업데이트 알림 설정",
        path: "/info/media-version-update-alert-settings",
      },
      {
        id: "trend_data_management",
        name: "Trend 데이터 관리",
        path: "/info/trend-data-management",
      },
    ],
  },
];